import { generateToken, validateEmail } from '../utils/generic-utilities.es6';
import { safeGTMuaEventsPusher } from '../utils/gtm-utilities.es6';
import { close as closeOverlay } from './overlay';
import 'snackbar';

const ERROR_CLASS = 'error';
let form;
let emailInput;
let emailErrorLabel;
let privacyCheckbox;
let privacyErrorLabel;
let generalErrorLabel;
let sendButton;
let sku;

function toggleError(hasError, label, input) {
    if (hasError) {
        label.removeAttribute('hidden');
    } else {
        label.setAttribute('hidden', true);
    }
    if (input) {
        input.classList.toggle(ERROR_CLASS, hasError);
    }
}

function toggleEmailError(hasError) {
    toggleError(hasError, emailErrorLabel, emailInput);
}

function togglePrivacyError(hasError) {
    toggleError(hasError, privacyErrorLabel, privacyCheckbox);
}

function toggleGeneralErrorMessage(hasError) {
    toggleError(hasError, generalErrorLabel);
}

function handleSuccess() {
    const isMobileScreenWidth = window.innerWidth < 768;
    closeOverlay('#product-interest-overlay');

    // eslint-disable-next-line no-undef
    Snackbar.show({
        backgroundColor: null,
        customClass: 'tick-icon',
        pos: isMobileScreenWidth ? 'bottom-center' : 'bottom-left',
        showAction: false,
        text: form.dataset.successMessage,
        width: null
    });

    safeGTMuaEventsPusher('nonInteractionEvent', 'product page', 'product interest', 'saved', { sku });
}

function validateForm() {
    const isEmailValid = validateEmail(emailInput.value);
    toggleEmailError(!isEmailValid);
    togglePrivacyError(!privacyCheckbox.checked);
    let errorMessage = '';
    if (!isEmailValid && !privacyCheckbox.checked) {
        safeGTMuaEventsPusher('nonInteractionEvent', 'product page', 'product interest error', 'invalid email and privacy not selected', { sku });
    } else {
        errorMessage = !privacyCheckbox.checked ? 'privacy not selected' : 'invalid email';
        safeGTMuaEventsPusher('nonInteractionEvent', 'product page', 'product interest error', errorMessage, { sku });
    }
    return isEmailValid && privacyCheckbox.checked;
}

async function handleSubmit(event) {
    sku = document.querySelector('select[name=size]').value;
    safeGTMuaEventsPusher('interactionEvent', 'product page', 'product interest send button', 'click', { sku });
    event.preventDefault();

    toggleGeneralErrorMessage(false);

    if (!validateForm()) {
        return;
    }

    const productInterestEndpoint = form.action;
    const email = emailInput.value;
    const [, country, language] = window.location.pathname.split('/');

    sendButton.setAttribute('disabled', true);

    try {
        const response = await fetch(productInterestEndpoint, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                tokio: generateToken(email)
            },
            body: JSON.stringify({
                email,
                sku,
                country,
                language
            })
        });

        if (response.status === 200) {
            handleSuccess();
        } else {
            toggleGeneralErrorMessage(true);
            safeGTMuaEventsPusher('nonInteractionEvent', 'product page', 'product interest error', 'service', { sku });
        }
    } catch (e) {
        toggleGeneralErrorMessage(true);
        safeGTMuaEventsPusher('nonInteractionEvent', 'product page', 'product interest error', 'network', { sku });
    } finally {
        sendButton.removeAttribute('disabled');
    }
}

function bindEvents() {
    form = document.querySelector('#product-interest-overlay form');
    form.addEventListener('submit', handleSubmit);
    emailInput = form.querySelector('input[type=email]');
    emailErrorLabel = form.querySelector('.email-error');
    privacyCheckbox = form.querySelector('input[type=checkbox]');
    privacyErrorLabel = form.querySelector('.privacy-error');
    generalErrorLabel = form.querySelector('.general-error');
    sendButton = form.querySelector('button');

    emailInput.addEventListener('focus', () => {
        toggleEmailError(false);
    });
    emailInput.addEventListener('blur', () => {
        toggleEmailError(!validateEmail(emailInput.value));
    });
    privacyCheckbox.addEventListener('click', () => {
        togglePrivacyError(!privacyCheckbox.checked);
    });
}

export function load() {
    bindEvents();
}
